/*
    Setup Core plugin (namespaces, configs, etc)
*/
; (function (undefined) {
    // (0, eval)('this') is a robust way of getting a reference to the global object
    // For details, see http://stackoverflow.com/questions/14119988/return-this-0-evalthis/14120023#14120023
    var window = this || (0, eval)('this');

    inovestor = window.inovestor || {};
    inovestor.ms = inovestor.ms || {};
    inovestor.ms.core = inovestor.ms.core || {};

    inovestor.ms.core.config = {};
    inovestor.ms.core.errors = {
        unhandled: 100,
        apiError: 101,
        invalidIdentifier: 102,
    };

    inovestor.ms.core.currentLanguage = 'en';

    inovestor.ms.core.componentConfigurations = [];

    inovestor.ms.core.templatesCache = function () {
        if (inovestor.ms.core.isNullOrUndefined(window.inoMsTemplatesCache))
            window.inoMsTemplatesCache = {};
        return window.inoMsTemplatesCache || {};
    };

    inovestor.ms.core.instances = new (function () {
        // Private variables
        var that = this;
        that._instances = [];

        return {
            register: function (instance, onLanguageChanged) {
                if (typeof instance === 'object')
                    that._instances.push({ plugin: instance, onLanguageChanged: onLanguageChanged });
            },
            updateLanguage: function () {
                for (var instanceIndex = 0; instanceIndex < that._instances.length; instanceIndex++) {
                    var instance = that._instances[instanceIndex];
                    if (typeof instance == 'object' && typeof instance.plugin == 'object')
                        instance.onLanguageChanged.call(instance.plugin);
                }
            }
        };
    })();
})();
; (function (inovestor) {
    inovestor.ms.libRef = inovestor.ms.libRef || {};

    if (typeof module === "object" && typeof module.exports === "object") {
        inovestor.ms.libRef.jQuery = require("jquery");
        inovestor.ms.libRef.ko = require("knockout");
    } else {
        inovestor.ms.libRef.jQuery = window.jQuery;
        inovestor.ms.libRef.ko = window.ko;
    }
})(inovestor);
; (function ($, inovestor, undefined) {
    /* 
        Simple function to check if value is null or undefined
    */
    inovestor.ms.core.isNullOrUndefined = function (value) {
        return typeof value === 'undefined' || value === null;
    }

    /* 
        Simple function to check if string is empty
    */
    inovestor.ms.core.isEmptyString = function (value) {
        return inovestor.ms.core.isNullOrUndefined(value) || typeof value !== 'string' || value.trim().length === 0;
    }

    /*
       Returns the resource model of the current language
    */
    inovestor.ms.core.getCurrentResource = function (resourceModel) {
        if (inovestor.ms.core.isNullOrUndefined(resourceModel))
            throw 'resourceModel is null or undefined';

        var currentResourceModel = resourceModel[inovestor.ms.core.currentLanguage];
        if (inovestor.ms.core.isNullOrUndefined(currentResourceModel))
            throw 'resourceModel has no configured language for ' + inovestor.ms.core.currentLanguage;

        return currentResourceModel;
    };

    /*
       Gets the best number divider possible based on the biggest number in the list of numbers
    */
    inovestor.ms.core.getNumberDivider = function (numbers) {
        var divider = 1;

        if (!inovestor.ms.core.isNullOrUndefined(numbers) && Array.isArray(numbers)) {
            var largestNumberInList = Math.max.apply(null, numbers);
            var maxPossibleValue = 999999;
            if (typeof largestNumberInList === 'number' && !isNaN(largestNumberInList)) {
                var value = largestNumberInList;
                while (value / divider > maxPossibleValue)
                    divider *= 1000;
            }
        }

        return divider;
    };

    /*
        Returns a random string (as random as Math.random() can be) that respects the GUID format.
    */
    inovestor.ms.core.getPseudoGuid = function () {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    };

    /*
        Gets template for plugin using file path provided. Callback is required.
    */
    inovestor.ms.core.getTemplate = function (fileCacheKey, filePath) {
        if (inovestor.ms.core.isEmptyString(fileCacheKey))
            throw "fileCacheKey is null or undefined";

        if (inovestor.ms.core.isEmptyString(filePath))
            throw "filePath is null or undefined";

        if (inovestor.ms.core.isNullOrUndefined(inovestor.ms.core.config.versionId))
            throw "versionId is null or undefined";

        // Create deferred
        var defer = $.Deferred();

        // Check if template in cache
        var templateCache = inovestor.ms.core.templatesCache();
        if (!inovestor.ms.core.isNullOrUndefined(templateCache[fileCacheKey])) {
            defer.resolve(templateCache[fileCacheKey]);
        }
        else {
            // Create url used for the plugin
            var templateUrl = filePath + '?_=' + inovestor.ms.core.config.versionId;
            $.ajax(templateUrl, { type: 'GET' }).then(function (template) {
                if (inovestor.ms.core.isNullOrUndefined(templateCache[filePath]))
                    templateCache[fileCacheKey] = {};

                templateCache[fileCacheKey] = template;
                defer.resolve(template);
            }).fail(function () {
                defer.resolve(false);
            });
        }

        return defer.promise();
    };

    /*
      Global function to be used when calling the API.
    */
    inovestor.ms.core.ajaxApi = function (relativeUrl, options, apiBaseUrl) {
        // Allow overwrite of the apiBaseUrl
        if (inovestor.ms.core.isNullOrUndefined(apiBaseUrl))
            apiBaseUrl = inovestor.ms.core.config.apiBaseUrl;

        if (inovestor.ms.core.isNullOrUndefined(apiBaseUrl))
            throw "apiBaseUrl is null or undefined";

        if (inovestor.ms.core.isNullOrUndefined(relativeUrl))
            throw "relativeUrl is null or undefined";

        if (inovestor.ms.core.isNullOrUndefined(options))
            throw "options is null or undefined";

        // Force caching at false
        options.cache = false;

        // Create url used for the plugin
        var url = inovestor.ms.core.concatUrl(apiBaseUrl, relativeUrl);

        if (!inovestor.ms.core.isNullOrUndefined(inovestor.ms.core.ajaxApiInterceptor)) {
            return inovestor.ms.core.ajaxApiInterceptor(url, options);
        } else {
            return $.ajax(url, options);
        }
    };

    inovestor.ms.core.ajaxApiInterceptor = null;

    /*
      Global function used to get the absolute Managed Solutions URL.
    */
    inovestor.ms.core.concatUrl = function (absoluteUrl, relativeUrl) {
        if (inovestor.ms.core.isNullOrUndefined(absoluteUrl))
            throw "absoluteUrl is null or undefined";

        if (inovestor.ms.core.isNullOrUndefined(relativeUrl))
            throw "relativeUrl is null or undefined";

        // Create url used for the plugin
        var url = absoluteUrl +
            (absoluteUrl.match(/\/$/) != null ? '' : '/') + // makes sure Url ends in slash at the end of this point
            (relativeUrl.match(/^\//) != null ? relativeUrl.substr(1, relativeUrl.length) : relativeUrl); // check if Url starts with a slash (removing it if it does)

        return url;
    }

    /*
        Global function to be called when changing the language. 
        All plugins should point to this function in order to change language accross all plugins.
    */
    inovestor.ms.core.setLanguage = function (language) {
        var current = inovestor.ms.core.currentLanguage;
        if (!inovestor.ms.core.isNullOrUndefined(language) && current !== language && (language === 'en' || language === 'fr')) {
            inovestor.ms.core.currentLanguage = language;
            inovestor.ms.core.instances.updateLanguage();
        }
    };

    /*
        String format method passing in both the string format and the object values
    */
    inovestor.ms.core.stringFormat = function (strFormat, formatValuesObject) {
        if (!inovestor.ms.core.isNullOrUndefined(strFormat) && typeof strFormat === 'string') {
            var finalString = strFormat;
            for (var propertyName in formatValuesObject) {
                var value = '';
                var propertyVal = formatValuesObject[propertyName];
                if (typeof propertyVal === 'function')
                    value = propertyVal();
                else if (typeof propertyVal === 'string')
                    value = propertyVal;
                else if (!inovestor.ms.core.isNullOrUndefined(propertyVal))
                    value = propertyVal.toString();

                // $0 is a special value with RegExp (at least in IE11) so we need to escape $
                // And yes, replacing $ by $$$ will give $$
                if (typeof value === 'string') {
                    value = value ? value.replace('$', '$$$') : value;
                }

                var reg = new RegExp("\\{" + propertyName + "\\}", "gm");
                finalString = finalString.replace(reg, value);
            }

            return finalString;
        }

        return '';
    };

    /*
       Global function to get HTML Error Template
    */
    inovestor.ms.core.getErrorTemplate = function (language) {
        var enResources = { warning: 'Warning!', errorOccured: 'An error occurred. Please try again later.' };
        var frResources = { warning: 'Attention!', errorOccured: 'Une erreur est survenue. Veuillez réessayer plus tard.' };

        var template =
            '<div class="alert alert-danger">' +
            '<h4><i class="fa fa-warning"></i> {warning}</h4>{errorOccured}' +
            '</div>';

        if (language === 'fr')
            return inovestor.ms.core.stringFormat(template, frResources);

        return inovestor.ms.core.stringFormat(template, enResources);
    };

    /*
      Global function to get HTML Invalid Identifier
    */
    inovestor.ms.core.getInvalidIdentifierTemplate = function (language) {
        var enResources = { warning: 'Warning!', errorOccured: 'We could not find the security you are looking for.' };
        var frResources = { warning: 'Attention!', errorOccured: 'Nous n’avons pas trouvé le titre que vous cherchiez.' };

        var template =
            '<div class="alert alert-warning">' +
            '<i class="fa fa-warning"></i> {errorOccured}' +
            '</div>';

        if (language === 'fr')
            return inovestor.ms.core.stringFormat(template, frResources);

        return inovestor.ms.core.stringFormat(template, enResources);
    };

    /*
     Global function to get HTML Loading Indicator Template
    */
    inovestor.ms.core.getLoadingIndicatorTemplate = function (language) {
        var enResources = { loading: 'Loading' };
        var frResources = { loading: 'Chargement' };

        var template =
            '<div class="text-center loading-indicator">' +
            '<div class=\"loading-indicator-content-wrapper\">' +
            '<div class="small">{loading}</div>' +
            '<span class="seperator"></span>' +
            '<i class="fa fa-2x fa-circle-o-notch fa-spin"></i>' +
            '</span>' +
            '</div>';

        if (language === 'fr')
            return inovestor.ms.core.stringFormat(template, frResources);

        return inovestor.ms.core.stringFormat(template, enResources);
    };

    /*
     Global function to sort an array
    */
    inovestor.ms.core.sortArray = function (array, direction, comparison) {
        if (array == null) {
            return [];
        }

        for (var oIndex = 0; oIndex < array.length; oIndex++) {
            var oItem = array[oIndex];
            for (var iIndex = oIndex + 1; iIndex < array.length; iIndex++) {
                var iItem = array[iIndex];
                var isOrdered = comparison(oItem, iItem);
                if (isOrdered == direction) {
                    array[iIndex] = oItem;
                    array[oIndex] = iItem;
                    oItem = iItem;
                }
            }
        }

        return array;
    };

    /*
    Generate a standardized Error
   */
    inovestor.ms.core.generateError = function (errorCode, errorCallStack, errorSource, originalRequest) {
        if (inovestor.ms.core.isNullOrUndefined(errorCode)) {
            errorCode = inovestor.ms.core.errors.unhandled;
        }

        return {
            errorCode: errorCode,
            callStack: errorCallStack,
            source: errorSource,
            originalRequest: originalRequest
        };
    };

    /*
      Compare two values
    */
    inovestor.ms.core.areEqual = function (value1, value2) {
        // Check for nulls
        var isVal1Null = inovestor.ms.core.isNullOrUndefined(value1);
        var isVal2Null = inovestor.ms.core.isNullOrUndefined(value2);

        var val1Type = isVal1Null ? '' : typeof value1;
        var val2Type = isVal2Null ? '' : typeof value2;

        // Handle the null cases
        if (isVal1Null || isVal2Null) {
            // If one of the types is a boolean, you can assume null means false
            if (val1Type === 'boolean')
                return value1 === false;
            else if (val2Type === 'boolean')
                return value2 === false;
            // SPECIAL UI CASE: empty string means null
            if (val1Type === 'string')
                return inovestor.ms.core.isEmptyString(value1);
            else if (val2Type === 'string')
                return inovestor.ms.core.isEmptyString(value2);

            // Return if both are null
            return isVal1Null === isVal2Null;
        }

        // Handle other cases
        if (val1Type === val2Type)
            return value1 === value2;
        else if (val1Type === 'number' && val2Type === 'string')
            return parseFloat(value2) === value1;
        else if (val2Type === 'number' && val1Type === 'string')
            return parseFloat(value1) === value2;

        return value1 === value2;
    };

    /*
      Get Number value
    */
    inovestor.ms.core.getNumber = function (input) {
        if (!inovestor.ms.core.isNullOrUndefined(input)) {
            if (typeof input === 'number')
                return input;
            else if (typeof input === 'string') {
                var parsedNumber = parseFloat(input);
                return isNaN(parsedNumber) ? null : parsedNumber;
            }
        }

        return null;
    };

    /**
     * Accepts a localized string representing a number and returns the
     * correct numerical value
     * 
     * @param {string} numString - Localized FR/EN string representing a number
     * @return {number} - Numerical value for the input string
     */
    inovestor.ms.core.numberStringToNumber = function (numString) {
        var origNumString = numString;
        var currentLang = inovestor.ms.core.currentLanguage;
        var thousandsDelimiter = currentLang === 'en' ? ',' : ' ';
        var decimalDelimiter = currentLang === 'en' ? '.' : ',';

        if (!inovestor.ms.core.isNullOrUndefined(numString) && numString !== '') {
            numString = numString + '';

            var isNegative = false;
            // Check if we're dealing with a negative number
            if (numString.charAt(0) === '-') {
                isNegative = true;
                numString = numString.slice(1);
            }

            // If there are non-numeric characters at this point return
            var numberOfLetters = numString.match(/[^0-9$.,\ ]/g) || [];
            if (numberOfLetters.length > 0)
                return '-';

            if (thousandsDelimiter === ',')
                numString = numString.replace(/,/g, '');
            else
                numString = numString.replace(/ /g, '');

            // ParseFloat() only works with '.' for decimals
            if (decimalDelimiter === ',')
                numString = numString.replace(/,/g, '.');

            var parsedNumber = parseFloat(numString);

            if (!isNaN(parsedNumber))

                return isNegative ? parsedNumber * -1 : parsedNumber;
            else
                return origNumString;
        } else
            return '-';
    };

    /**
     * Accepts a numerical value, rounds it, and adds abbreviations for billions,
     * millions, or thousands
     * 
     * @param {number} num - The number to be rounded
     * @param {number} digits - The amount of digits after the decimal
     * @returns {string} - The rounded number with the correct abbreviation 
     */
    inovestor.ms.core.moneyFormat = function (num, digits) {

        if (!inovestor.ms.core.isNullOrUndefined(num) && typeof num === 'number') {
            if (num >= 1000000000 || num <= -1000000000) {
                return (num / 1000000000).toFixed(digits).replace(/\.0$/, '') + 'B';
            }
            if (num >= 1000000 || num <= -1000000) {
                return (num / 1000000).toFixed(digits).replace(/\.0$/, '') + 'M';
            }
            if (num >= 1000 || num <= -1000) {
                return (num / 1000).toFixed(digits).replace(/\.0$/, '') + 'k';
            }
        }

        return num;
    };

    /**
     * Accepts a string of an abbreviated number ending it kK, mM, or bB and converts
     * it to the correct numerical value
     * 
     * @param {string} abbrNumString - The abbreviated number string
     * @returns {number} - The numerical value of the input string
     */
    inovestor.ms.core.abbreviatedStringToNumber = function (abbrNumString) {
        if (!inovestor.ms.core.isNullOrUndefined(abbrNumString)) {
            var currentLang = inovestor.ms.core.currentLanguage;
            var thousandsDelimiter = currentLang === 'en' ? ',' : ' ';
            var decimalDelimiter = currentLang === 'en' ? '.' : ',';
            abbrNumString = abbrNumString.trim();

            if (thousandsDelimiter === ',')
                abbrNumString = abbrNumString.replace(/,/g, '');
            else
                abbrNumString = abbrNumString.replace(/ /g, '');

            if (decimalDelimiter === ',')
                abbrNumString = abbrNumString.replace(/,/g, '.');

            if (abbrNumString.length > 1) {
                var lastChar = abbrNumString.substr(abbrNumString.length - 1);
                if (/[kKmMbBgG]/g.test(lastChar)) {
                    lastChar = lastChar.toUpperCase();
                    abbrNumString = abbrNumString.substr(0, abbrNumString.length - 1);
                    var num = inovestor.ms.core.numberStringToNumber(abbrNumString);
                    if (typeof num === 'number') {
                        switch (lastChar) {
                            case 'K':
                                num = num * 1000;
                                break;
                            case 'M':
                                num = num * 1000000;
                                break;
                            case 'B':
                                if (currentLang == 'en')
                                    num = num * 1000000000;
                                break;
                            case 'G':
                                if (currentLang == 'fr')
                                    num = num * 1000000000;
                                break;
                        }
                        return inovestor.ms.core.numberStringToNumber(num);
                    } else {
                        return '-';
                    }
                } else {
                    return inovestor.ms.core.numberStringToNumber(abbrNumString);
                }
            } else {
                return inovestor.ms.core.numberStringToNumber(abbrNumString);
            }
        } else {
            return '-';
        }
    }

    /**
     * Capitalizes the first letter of a string
     * 
     * @param {string} string - The string to be modified
     * @returns {string} - The input string with a capitalized first letter
     */
    inovestor.ms.core.capitalizeFirstLetter = function (string) {

        if (!inovestor.ms.core.isNullOrUndefined(string)) {
            string = string.toLowerCase();
            var strArray = string.split(' ');

            for (var i = 0; i < strArray.length; i++) {
                var tmp = strArray[i];
                tmp = tmp.charAt(0).toUpperCase();
                if (strArray[i].length > 0)
                    tmp += strArray[i].slice(1);

                strArray[i] = tmp;
            }

            return strArray.join(' ');
        } else {
            return '-';
        }

    }

    /**
     * Accepts a camel case string and seperates the worse while
     * changing the first letter of each new word to uppercase. Does
     * not seperate when there are multiple uppercase letters in a row.
     * 
     * @param {string} string - The value to be formatted
     * @returns {string} - The un-camel cased string
     */
    inovestor.ms.core.unCamelCase = function (string) {
        if (!inovestor.ms.core.isNullOrUndefined(string) && typeof string === 'string') {
            return string
                // insert a space between lower & upper
                .replace(/([a-z])([A-Z])/g, '$1 $2')
                // space before last upper in a sequence followed by lower
                .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
                // uppercase the first character
                .replace(/^./, function (str) { return str.toUpperCase(); })
        } else {
            return '-';
        }
    }

    inovestor.ms.core.formatMicToMarketName = function (mic, language) {
        if (inovestor.ms.core.isNullOrUndefined(mic)) return mic;

        if (inovestor.ms.core.isNullOrUndefined(language))
            language = inovestor.ms.core.currentLanguage;
        else if (['en', 'fr'].indexOf(language.toLowerCase()) < 0)
            language = 'en';

        var mapping = {
            'CND': { en: 'CND Stocks', fr: 'Actions CND' },
            'SNPTSX': { en: 'S&P/TSX-Comp.', fr: 'S&P/TSX-Comp.' },
            'XTSE': { en: 'TSX', fr: 'TSX' },
            'XTSX': { en: 'TSX-V', fr: 'TSX-V' },
            'US': { en: 'US Stocks', fr: 'Actions US' },
            'SNP': { en: 'S&P500', fr: 'S&P500' },
            'XNYS': { en: 'NYSE', fr: 'NYSE' },
            'XASE': { en: 'AMEX', fr: 'AMEX' },
            'XNAS': { en: 'NASDAQ', fr: 'NASDAQ' },
            'ADR': { en: 'ADR', fr: 'ADR' },
            'OOTC': { en: 'OTHEROTC', fr: 'OTHEROTC' },
            'XOTC': { en: 'OTCBB', fr: 'OTCBB' }
        };

        if (mapping[mic.toUpperCase()])
            return mapping[mic.toUpperCase()][language.toLowerCase()];

        return mic;
    }

    /**
     * Provides helper functions to make a plugin Shareable. A Shareable
     * plugin use's the URL's hash to store data for the page that lets the
     * current view be shared or persisted.
     * 
     * @constructor
     * @param {string} baseUrl - The base url to append the hash to
     */
    inovestor.ms.core.Shareable = function () {

        var self = this;
        self.baseUrl = window.location.href.replace(window.location.hash, '');
        self.ownHashChange = false; // Whether the hashchange came setNavigation

        /**
         * Renders the sharing widget.
         * 
         * @param {string} selector - The DOM selector for where to insert the widget.
         */
        self.render = function (selector) {
            var self = this;

            if (inovestor.ms.core.isNullOrUndefined(selector))
                throw "Selector must not be null or undefined.";

            var elem = document.querySelector(selector);

            if (!inovestor.ms.core.isNullOrUndefined(elem)) {
                elem.innerHTML = self._getTemplate();
                self._addEvents();
            }
        };

        /**
         * Sets the URL's hash to a list of key/value pairs.
         * 
         * @param {Object} values - Key/value pairs to set in the URL's hash.
         */
        self.setNavigation = function (values) {
            if (inovestor.ms.core.isNullOrUndefined(values))
                throw "Values must not be null or undefined.";

            var hashStr = '';
            var prefix = '';

            for (var prop in values) {
                if (values.hasOwnProperty(prop)) {
                    var propValue = values[prop];
                    hashStr += inovestor.ms.core.stringFormat("{prefix}{prop}={propValue}",
                        { prefix: prefix, prop: prop, propValue: propValue });
                }

                prefix = '&';
            }

            var encodedHashStr = encodeURI(hashStr);
            if (window.location.hash !== ('#' + encodedHashStr)) {
                self.ownHashChange = true;
                window.location.hash = encodedHashStr;
            } else {
                self.ownHashChange = false;
            }
        };

        /**
         * Returns the full encoded URL that links to the plugin's 
         * current state.
         * 
         * @returns {string} - The full encoded URL.
         */
        self.getNavigation = function () {
            return encodeURI(self.baseUrl + window.location.hash);
        };

        /**
         * Returns an object of key/value pairs that contains all the values
         * in the URL's hash.
         * 
         * @returns {Object} - The key/value pairs in the URL's hash.
         */
        self.getNavigationValues = function () {
            var valuesObj = {};
            var hash = decodeURI(window.location.hash);

            if (!inovestor.ms.core.isEmptyString(hash)) {
                hash.slice(1).split('&').map(function (item) {
                    var itemArr = item.split('=');
                    var key = itemArr[0];
                    var value = itemArr[1];

                    value ? valuesObj[key] = value : null;
                });
            }

            return valuesObj;
        };

        /**
         * Adds the click event for the share button in the widget.
         * Called only when render() is called for iframe solutions.
         */
        self._addEvents = function () {
            var self = this;
            var shareBtn = document.querySelector('.ino-share-button');

            shareBtn.addEventListener('click', function (evt) {
                var inputElem = document.getElementById('ino-share-input');
                inputElem.value = self.getNavigation();
                self._copy(evt.target);
            });
        };

        /**
         * Copies the full URL to the clipboard.
         * https://www.sitepoint.com/javascript-copy-to-clipboard/
         * 
         * @param {DOMElement} elem - The DOM element for the Share button in the widget.
         */
        self._copy = function (elem) {
            var selector = elem.dataset.copytarget;
            var input = selector ? document.querySelector(selector) : null;

            if (!inovestor.ms.core.isNullOrUndefined(input) && input.select) {
                input.select();
                var toast = null;

                try {
                    document.execCommand('copy');
                    //input.blur();
                    toast = document.querySelector('#ino-share-toast-success');
                } catch (err) {
                    toast = document.querySelector('#ino-share-toast-failure');
                }

                toast.className += " show";
                setTimeout(function () { toast.className = toast.className.replace("show", ""); }, 3000);
            }
        };

        self.shareableTemplate = '\
            <div class="ino-share-widget">\
                <div class="input-group">\
                    <span class="input-group-btn">\
                        <button data-copytarget="#ino-share-input" class="ino-share-button btn btn-default"><i class="fa fa-share-square-o" aria-hidden="true"></i>{share}</button>\
                    </span>\
                    <input id="ino-share-input" class="form-control" readonly>\
                </div>\
                <div id="ino-share-toast-success" class="ino-share-toast">{copied}</div>\
                <div id="ino-share-toast-failure" class="ino-share-toast">{copyPrompt}</div>\
            </div>\
        ';

        /**
         * Gets the localized template for the Share widget.
         * 
         * @returns {string} - The localized template string.
         */
        self._getTemplate = function () {
            var self = this;

            var resources = {
                en: {
                    share: ' Share',
                    copied: 'Text copied to clipboard!',
                    copyPrompt: 'Press Ctrl/CMD + C to copy link'
                },
                fr: {
                    share: ' Partager',
                    copied: 'Texte copié dans le presse-papiers!',
                    copyPrompt: 'Appuyez sur Ctrl/CMD + C pour copier le lien'
                }
            };

            return inovestor.ms.core.stringFormat
                (self.shareableTemplate, resources[inovestor.ms.core.currentLanguage]);
        }

        self.init = function () {
            var self = this;

            // Custom Event Polyfill for IE
            // https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
            (function () {

                if (typeof window.CustomEvent === "function") return false;

                function CustomEvent(event, params) {
                    params = params || { bubbles: false, cancelable: false, detail: undefined };
                    var evt = document.createEvent('CustomEvent');
                    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
                    return evt;
                }

                CustomEvent.prototype = window.Event.prototype;

                window.CustomEvent = CustomEvent;
            })();

            var event = new window.CustomEvent("browser-navigation-hashchange", null);

            window.onhashchange = function () {
                // Fire custom even if hash change came from browser nav buttons
                if (!self.ownHashChange) {
                    document.dispatchEvent(event);
                }

                self.ownHashChange = false;
            };
        };

        self.init();
    }

    inovestor.ms.core.getComponentConfigurations = function (component, context) {
        var componentConfigurations = [];

        // highest priority (specified context)
        if (context != null) {
            inovestor.ms.core.componentConfigurations.filter(function (x) {
                return x.component === component && x.context === context;
            }).reverse().forEach(function (x) {
                componentConfigurations.push(x.configuration);
            });
        }

        // lowest priority (global without context)
        inovestor.ms.core.componentConfigurations.filter(function (x) {
            return x.component === component && inovestor.ms.core.isNullOrUndefined(x.context);
        }).reverse().forEach(function (x) {
            componentConfigurations.push(x.configuration);
        });

        // highest priority are first in the array so in need to loop in reverse order
        var result = {};
        for (var i = componentConfigurations.length - 1; i >= 0; i--) {
            $.extend(true, result, componentConfigurations[i]);
        }
        return result;
    }
})(inovestor.ms.libRef.jQuery, inovestor);
